import DefaultModal from '@/components/organisms/common/modal/DefaultModal';
import { useState } from 'react';
import { ModalStaticFunctions } from 'antd/lib/modal/confirm';
import { UploadFile } from 'antd/es/upload/interface';
import { Button, Form, Input, message, Upload } from 'antd';
import api from '@/api';
import { readBytes } from '@/utils/fileExtension';

export type ManageCompanyRegistrationModalProps = {
  visible: boolean;
  onClose: () => void;
  modal?: Pick<ModalStaticFunctions, 'info' | 'confirm'>;
};

const ManageCompanyRegistrationModal = ({ visible, onClose, modal }: ManageCompanyRegistrationModalProps) => {
  const [licenseFiles, setLicenseFiles] = useState<UploadFile[]>([]);
  const [stampFiles, setStampFiles] = useState<UploadFile[]>([]);
  const [files, setFiles] = useState<UploadFile[]>([]);

  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    console.log(values);

    const license = await readBytes(values.license.fileList[0]);
    const stamp = await readBytes(values.stamp.fileList[0]);

    console.log(license);
    console.log(stamp);

    api
      .post('/company', 'pcompany.PbCompany', {
        ...values,
        file: [
          {
            type: 'license',
            data: license,
          },
          {
            type: 'stamp',
            data: stamp,
          },
        ],
      })
      .then(() => {
        onClose();
      })
      .catch((e) => {
        message.error('가입 신청에 실패했습니다.');
      });
  };

  return (
    <DefaultModal
      modalVisible={visible}
      titleText="회사 등록"
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="name" label="회사명" rules={[{ required: true, message: '회사명을 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="corporationNo" label="법인번호" rules={[{ required: true, message: '법인번호를 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="businessNo" label="사업자번호" rules={[{ required: true, message: '사업자번호를 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="representative" label="대표자" rules={[{ required: true, message: '대표자 명의를 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="addr1" label="주소" rules={[{ required: true, message: '주소를 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="license" label="사업자 등록증" rules={[{ required: true, message: '사업자등록증을 업로드하세요.' }]}>
          <Upload
            name="license"
            multiple={false}
            fileList={licenseFiles}
            // showUploadList={false}
            customRequest={(option) => {
              const { onSuccess } = option;
              if (onSuccess) {
                onSuccess({ status: 'done' }, new XMLHttpRequest());
              }
            }}
            onChange={(info) => {
              setLicenseFiles(info.fileList.slice(-1));
            }}
          >
            <Button>파일 선택</Button>
          </Upload>
        </Form.Item>
        <Form.Item name="stamp" label="사업자 직인" rules={[{ required: true, message: '사업자직인을 업로드하세요.' }]}>
          <Upload
            name="stamp"
            multiple={false}
            fileList={stampFiles}
            // showUploadList={false}
            customRequest={(option) => {
              const { onSuccess } = option;
              if (onSuccess) {
                onSuccess({ status: 'done' }, new XMLHttpRequest());
                // option.onSuccess({ status: 'error', response: '중복된 파일' }, option.file);
                // option.onSuccess({ status: 'done' }, option.file);
              }
            }}
            onChange={(info) => setStampFiles(info.fileList.slice(-1))}
          >
            <Button>파일 선택</Button>
          </Upload>
        </Form.Item>
        <div className="flex justify-center space-x-5">
          <Button>취소</Button>
          <Button htmlType="submit" type="primary">
            가입 신청
          </Button>
        </div>
      </Form>
    </DefaultModal>
  );
};

export default ManageCompanyRegistrationModal;
